import Axios, { AxiosResponse } from 'axios';

import { PortalConfig as PortalConfigContextType } from 'src/context';
import { PortalConfig as PortalConfigEntityType } from 'src/entities/PortalConfig';
import { PortalSetupInput } from 'src/routes/onboarding/setup/types';
import { getCookie } from 'src/utils/StorageUtils';

export default class OnboardingClient {
  static SavePortalOnboarding(
    portalConfig: PortalConfigContextType,
    values: PortalSetupInput,
  ): Promise<AxiosResponse<PortalConfigEntityType>> {
    const portalApiBaseURL = portalConfig.AWS.API.endpoints[2].endpoint;
    const fbBrowserId = getCookie('_fbp'); // get Facebook browser ID value from _fbp cookie
    const fbClickId = getCookie('_fbc'); // get Facebook click ID value from the _fbc cookie
    const googleClickId = getCookie('_gcl_aw'); // get Google click ID value from the _gcl_aw cookie
    const tiktokBrowserId = getCookie('_ttp'); // get TikTok browser/pixel ID value from the _ttp cookie
    const tiktokClickId = getCookie('ttclid'); // get TikTok click ID value from the ttclid cookie
    return Axios({
      method: 'post',
      url: `${portalApiBaseURL}/portal/any/setup`,
      data: {
        ...values,
        fbBrowserId,
        fbClickId,
        googleClickId,
        tiktokBrowserId,
        tiktokClickId,
      },
    });
  }

  static GetPortalSetup(
    portalConfig: PortalConfigContextType,
    stackId: string,
    email: string,
    password: string,
  ): Promise<AxiosResponse<string>> {
    const portalApiBaseURL = portalConfig.AWS.API.endpoints[2].endpoint;
    return Axios({
      method: 'get',
      url: `${portalApiBaseURL}/portal/any/setup`,
      params: {
        stackId,
        email,
        password,
      },
    });
  }

  static GetPortalURLHealth(portalURL: string): Promise<AxiosResponse<string>> {
    return Axios({
      method: 'get',
      url: `${portalURL}/health`,
    });
  }
}
